import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
/* ---------------- STYLES ---------------- */
const labelStyle = {
  fontSize: "18px",
  fontWeight: "600",
  color: "#000",
  marginBottom: "4px",
};

const inputStyle = {
  fontSize: "14px",
  border: "1px solid #0C3B6C",
  padding: "10px",
  borderRadius: "8px",
  width: "100%",
};

/* ---------------- COMPONENT ---------------- */
const NonTeachingStaffRegistration = () => {
  const navigate = useNavigate();
  const currentSessionId = localStorage.getItem("currentSessionId");

  const initialData = {
    name: "",
    contactNumber: "",
    alternateContactNumber: "",
    email: "",
    designation: "",
    gender: "",
    dob: "",
    age: "",
    state: "",
    city: "",
    address: "",
    qualification: "",
    profilePicture: null,
    baseSalary: 0,
    allowances: 0,
    totalSalary: 0,
    joiningDate: "",
    username: "",
    password: "",
  };

  const [formData, setFormData] = useState(initialData);
  const [designations, setDesignations] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [filteredStaff, setFilteredStaff] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  
const getDesignationNameById = (id) => {
  const d = designations.find(
    (des) => String(des._id) === String(id)
  );
  return d?.designationName || "";
};

  /* ---------------- FETCH DATA ---------------- */
  useEffect(() => {
    if (!currentSessionId) return;

    const fetchData = async () => {

      try {
        const [desRes, staffRes] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/allDesignations/getDesignations`,
            { params: {sessionId: currentSessionId,  
        type: "Non-Teacher",  } }
          ),
          axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaff/getAllNonTeachingStaff`,
            { params: { sessionId: currentSessionId } }
          ),
        ]);
                setDesignations(desRes.data || []);
        setStaffList(staffRes.data || []);
        setFilteredStaff(staffRes.data || []);
      } catch (error) {
        console.error("Error loading data:", error);
      }
    };

    fetchData();
  }, [currentSessionId]);

  /* ---------------- SEARCH ---------------- */
  useEffect(() => {
    setFilteredStaff(
      staffList.filter((s) =>
        s.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, staffList]);

  /* ---------------- HELPERS ---------------- */
  const calculateAge = (dob) => {
    if (!dob) return "";
    const birth = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    if (
      today.getMonth() < birth.getMonth() ||
      (today.getMonth() === birth.getMonth() &&
        today.getDate() < birth.getDate())
    ) age--;
    return age;
  };

  /* Auto-generate username/password */
  useEffect(() => {
  if (formData.name && formData.designation && formData.dob) {
    const year = new Date(formData.dob).getFullYear();
    const random = Math.floor(1000 + Math.random() * 9000);

    const cleanName = formData.name.replace(/\s+/g, "");
    const desName = getDesignationNameById(formData.designation);
    const cleanDesignation = desName.replace(/\s+/g, "");

    setFormData((prev) => ({
      ...prev,
      username: `${cleanName}${year}${cleanDesignation}`,
      password: `${cleanName}${random}`,
    }));
  }
}, [formData.name, formData.designation, formData.dob, designations]);


  /* ---------------- INPUT HANDLERS ---------------- */
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
      age: name === "dob" ? calculateAge(value) : prev.age,
    }));
  };

  const handleSalaryChange = (e, key) => {
    const value = parseFloat(e.target.value) || 0;
    setFormData((prev) => ({
      ...prev,
      [key]: value,
      totalSalary:
        (key === "baseSalary" ? value : prev.baseSalary) +
        (key === "allowances" ? value : prev.allowances),
    }));
  };

  const resetForm = () => {
    setFormData(initialData);
    setSelectedStaff(null);
  };

useEffect(() => {
    if (!currentSessionId) return;

    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/allDesignations/getDesignations`, {
        params: {
          sessionId:currentSessionId,
          type:"Non-Teacher", 
        },
        
      })
      .then((res) => {
        setDesignations(res.data);
      })
      .catch((err) => {
        console.error("Designation fetch error:", err);
      });
  }, [currentSessionId]);
  /* ---------------- SUBMIT ---------------- */
 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const fd = new FormData();
    // Append form data
    Object.entries(formData).forEach(([key, value]) => fd.append(key, value));

    // Append sessionId to the form data (important!)
    fd.append("sessionId", currentSessionId);

    const url = selectedStaff
      ? `${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaff/updateNonTeachingStaff/${selectedStaff._id}`
      : `${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaff/createNonTeachingStaff`;

    const method = selectedStaff ? axios.put : axios.post;

    await method(url, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    alert(
      selectedStaff
        ? "Staff updated successfully!"
        : "Staff registered successfully!"
    );

    resetForm();

    // Fetch updated staff list
    const updated = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaff/getAllNonTeachingStaff`,
      { params: { sessionId: currentSessionId } }
    );

    setStaffList(updated.data);
    setFilteredStaff(updated.data);
  } catch (error) {
    console.error("Axios error:", error.response?.data);
    alert(error.response?.data?.message || "Error submitting form");
  } finally {
    setLoading(false);
  }
};


  /* ---------------- DELETE ---------------- */
const handleDelete = async (id) => {
  if (!window.confirm("Are you sure?")) return;

  try {
    // Append sessionId directly to the URL
    await axios.delete(
      ` ${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaff/deleteNonTeachingStaff/${id}?sessionId=${currentSessionId}`
    );

    // Remove deleted staff from the state
    setStaffList((prev) => prev.filter((s) => s._id !== id));
    setFilteredStaff((prev) => prev.filter((s) => s._id !== id));
  } catch (error) {
    console.error("Delete error:", error.response || error);
    alert(error.response?.data?.message || "Error deleting staff");
  }
};


  /* ---------------- EDIT ---------------- */
  const handleEdit = (staff) => {
    setSelectedStaff(staff);
    setFormData({
      ...initialData,
      ...staff,
      dob: staff.dob?.slice(0, 10),
      joiningDate: staff.joiningDate?.slice(0, 10),
      age: calculateAge(staff.dob),
      profilePicture: null,
      totalSalary:
        (staff.baseSalary || 0) + (staff.allowances || 0),
    });
  };
  /* ----------------------- JSX START --------------------------- */
  return (
    <div className="max-w-7xl mx-auto p-8">
      {/* MAIN TITLE */}
      <header className="mb-8 flex items-center gap-3">
        <h1 className="text-[18px] font-bold text-black">
          Non-Teaching Staff Registration
        </h1>
      </header>

      {/* FORM */}
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-lg shadow-lg"
        encType="multipart/form-data"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Name */}
          <div>
            <label style={labelStyle}>Full Name *</label>
            <input
              style={inputStyle}
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          {/* Contact */}
          <div>
            <label style={labelStyle}>Contact Number *</label>
            <input
              style={inputStyle}
              type="number"
              name="contactNumber"
              value={formData.contactNumber}
              onChange={handleChange}
              required
            />
          </div>

          {/* Alternate Contact */}
          <div>
            <label style={labelStyle}>Alternate Contact Number</label>
            <input
              style={inputStyle}
              type="number"
              name="alternateContactNumber"
              value={formData.alternateContactNumber}
              onChange={handleChange}
            />
          </div>

          {/* Email */}
          <div>
            <label style={labelStyle}>Email</label>
            <input
              style={inputStyle}
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
            
            />
          </div>

        

                    {/* DESIGNATION */}
<div>
  
  <label style={labelStyle}>Designation *</label>
  <select
    style={inputStyle}
    name="designation"
    value={formData.designation}
    onChange={handleChange}
    required
  >
    <option value="">Select Designation</option>
    {designations.map((d) => (
      <option key={d._id} value={d._id}>
        {d.designationName}
      </option>
    ))}
  </select>
</div>



          {/* Gender */}
          <div>
            <label style={labelStyle}>Gender *</label>
            <select
              style={inputStyle}
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              required
            >
              <option value="">Select Gender</option>
              {["Male", "Female", "Other"].map((g) => (
                <option key={g} value={g}>{g}</option>
              ))}
            </select>
          </div>

          {/* DOB */}
          <div>
            <label style={labelStyle}>Date of Birth</label>
            <input
              style={inputStyle}
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
            />
          </div>

          {/* Age */}
          <div>
            <label style={labelStyle}>Age</label>
            <input
              style={inputStyle}
              type="number"
              value={formData.age}
              readOnly
            />
          </div>

          {/* State */}
          <div>
            <label style={labelStyle}>State</label>
            <input
              style={inputStyle}
              type="text"
              name="state"
              value={formData.state}
              onChange={handleChange}
              
            />
          </div>

          {/* City */}
          <div>
            <label style={labelStyle}>City</label>
            <input
              style={inputStyle}
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              
            />
          </div>

          {/* Address */}
          <div className="md:col-span-2">
            <label style={labelStyle}>Address *</label>
            <textarea
              style={inputStyle}
              rows={3}
              name="address"
              value={formData.address}
              onChange={handleChange}
            ></textarea>
          </div>

          {/* Qualification */}
          <div>
            <label style={labelStyle}>Qualification</label>
            <input
              style={inputStyle}
              type="text"
              name="qualification"
              value={formData.qualification}
              onChange={handleChange}
            />
          </div>

          {/* Profile Picture */}
          <div>
            <label style={labelStyle}>Profile Picture</label>
            <input
              style={inputStyle}
              type="file"
              name="profilePicture"
              onChange={handleChange}
            />
          </div>

          {/* Salary */}
          <div>
            <label style={labelStyle}>Base Salary *</label>
            <input
              style={inputStyle}
              type="number"
              name="baseSalary"
              value={formData.baseSalary}
              onChange={(e) => handleSalaryChange(e, "baseSalary")}
            />
          </div>

          <div>
            <label style={labelStyle}>Allowances *</label>
            <input
              style={inputStyle}
              type="number"
              name="allowances"
              value={formData.allowances}
              onChange={(e) => handleSalaryChange(e, "allowances")}
            />
          </div>

          <div>
            <label style={labelStyle}>Total Salary</label>
            <input
              style={inputStyle}
              type="number"
              value={formData.totalSalary}
              readOnly
            />
          </div>

          {/* Username */}
          <div>
            <label style={labelStyle}>Username</label>
            <input
              style={inputStyle}
              type="text"
              name="username"
              value={formData.username}
              readOnly
            />
          </div>

          {/* Password */}
          <div>
            <label style={labelStyle}>Password</label>
            <input
              style={inputStyle}
              type="text"
              name="password"
              value={formData.password}
              readOnly
            />
          </div>

          {/* Joining Date */}
          <div>
            <label style={labelStyle}>Joining Date *</label>
            <input
              style={inputStyle}
              type="date"
              name="joiningDate"
              value={formData.joiningDate}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-8 flex gap-6">
          <button
            type="submit"
            disabled={loading}
            style={{
              background: "#0C3B6C",
              color: "white",
              padding: "12px 30px",
              borderRadius: "8px",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            {loading ? "Submitting..." : selectedStaff ? "Update" : "Register"}
          </button>

          <button
            type="button"
            onClick={resetForm}
            style={{
              background: "#d9534f",
              color: "white",
              padding: "12px 30px",
              borderRadius: "8px",
              fontSize: "18px",
              fontWeight: "600",
            }}
          >
            Reset
          </button>
        </div>
      </form>

      {/* STAFF LIST TABLE */}
      <div className="mt-10">
        <h1 className="text-[18px] font-bold mb-4">
          Non-Teaching Staff Management
        </h1>

        <div className="flex items-center justify-between mb-4">
          <input
            type="text"
            style={inputStyle}
            placeholder="Search by Name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <p className="font-semibold text-[14px]">
            Total Staff: {filteredStaff.length}
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full border">
            <thead className="bg-gray-200">
              <tr>
                <th className="p-3 border text-[14px]">Sr No.</th>
                <th className="p-3 border text-[14px]">Name</th>
                <th className="p-3 border text-[14px]">Contact</th>
                <th className="p-3 border text-[14px]">Designation</th>
                <th className="p-3 border text-[14px]">Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredStaff.map((s, index) => (
                <tr className="text-center bg-gray-50" key={s._id}>
                  <td className="p-2 border text-[14px]">{index + 1}</td>
                  <td className="p-2 border text-[14px]">{s.name}</td>
                  <td className="p-2 border text-[14px]">{s.contactNumber}</td>
                <td className="p-2 border text-[14px]">
  {s.designation?.designationName || "—"}
</td>

                  <td className="p-2 border space-x-3">
                    <button
                      onClick={() => navigate(`/nonTeachingStaff/${s._id}`)}
                      className="px-3 py-1 bg-green-600 text-white rounded text-[14px]"
                    >
                      View
                    </button>
                    <button
                      onClick={() => handleEdit(s)}
                      className="px-3 py-1 bg-yellow-500 text-white rounded text-[14px]"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(s._id)}
                      className="px-3 py-1 bg-red-600 text-white rounded text-[14px]"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>
    </div>
  );
};

export default NonTeachingStaffRegistration;